import { memo, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  AuraLayout,
  CashSpecialIcon,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";
import { REQUEST_ROUTES, TITLE_COLOR } from "../../constants";
import { useStore } from "../../store/globalState";

/** Short processing delay before advancing to the share screen (gallery only). */
const MINT_DELAY_MS = 1800;

/**
 * "Minting your request link" screen. In production this calls the
 * fund-request API; in the gallery the minted link is pre-seeded in
 * `useRequestStore`, so this just shows the processing animation and advances
 * to the Request Ready screen after a short, inspectable delay.
 */
export const MintingPage = memo(() => {
  const { t } = useTranslation("request");
  const { theme } = useStore();
  const navigate = useNavigate();

  const colorConfig = theme.whiteView;
  const { dropzoneColors, backgroundIcon } = colorConfig;

  const advancedRef = useRef(false);

  useEffect(() => {
    if (advancedRef.current) return;
    advancedRef.current = true;
    const timer = setTimeout(() => {
      navigate(REQUEST_ROUTES.REQUEST_READY);
    }, MINT_DELAY_MS);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            showSpinner
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <CashSpecialIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("minting.title")}
              highlightColor={TITLE_COLOR}
              secudnary={t("minting.subtitle")}
              secudnaryColor={TITLE_COLOR}
            />
          </section>
        </section>
      </Layout.Content>
    </AuraLayout>
  );
});
